module.exports = __webpack_public_path__ + "img/cuadros.ad0df5b0.svg";